import { CONTACT_COMMENT, DEFAULT_SUBSTATE, EMENInvoiceState } from './invoices-my-international.constants';

export function getSubStateComment(state: EMENInvoiceState, subState: string): string {
  const hasSubState = subState && subState !== DEFAULT_SUBSTATE;

  if (!hasSubState) {
    return state === EMENInvoiceState.NOT_VERIFIED ? CONTACT_COMMENT : '';
  }

  return subState;
}
